import type { roles as en } from '@/i18n/locales/en/roles';
import type { Translation } from '@/i18n/types';

export const roles: Translation<typeof en> = {
  form: {
    person: 'Pessoa',
    choose: 'Escolhe…',
    grant: 'Conceder {{label}}',
    revoke: 'Revogar {{label}}',
    back: 'Voltar',
  },
  company: {
    title: 'Administradores da empresa',
    lead: 'Um administrador de empresa gere as informações próprias da empresa, os departamentos, os membros e o aprovisionamento. Conceder e revogar ficam registados na auditoria.',
    label: 'administrador da empresa',
    rowsLabel: 'os membros da empresa',
  },
  department: {
    title: 'Administradores de departamento (treinador)',
    lead: 'Um administrador de departamento lê os membros e agregados deste departamento e, segundo a regra de acesso individual, as estatísticas individuais cobertas pela sua base de consentimento. Conceder e revogar ficam registados na auditoria.',
    label: 'administrador de departamento',
    rowsLabel: 'os membros do departamento',
  },
  admins: {
    title: 'Administradores da plataforma',
    lead: 'Um administrador da plataforma detém toda a autoridade, em qualquer âmbito. O alvo de uma nomeação tem de ter acesso próprio e ser uma identidade principal; o último administrador não pode ser destituído.',
    name: 'Nome',
    email: 'E-mail',
    retire: 'Destituir',
    rowsLabel: 'os administradores',
    searchPeople: 'Pesquisar pessoas',
    searchPlaceholder: 'Nome ou e-mail',
    person: 'Pessoa',
    choose: 'Escolhe…',
    noEligible: 'Nenhuma pessoa elegível corresponde — precisa de ter acesso próprio.',
    appoint: 'Nomear',
    usersLabel: 'os utilizadores da plataforma',
  },
};
